import { filters } from '@/config/filters';

export default {
  methods: {
    // Método para formatear moneda
    formatCurrency(value) {
      return filters.currency(value);
    },

    // Método para convertir a fecha
    toDate(value) {
      return filters.toDate(value);
    },

    // Método para formatear fecha
    formatDate(value) {
      return filters.dateFormat(value);
    },

    // Método para formatear fecha y hora
    formatDateTime(value) {
      return filters.dateTimeFormat(value);
    },

    // Método para eliminar HTML
    stripHtml(value) {
      return filters.striphtml(value);
    },

    // Método para formatear fecha y hora (DD/MM/YYYY HH:mm)
    formatDateTimeShort(value) {
      if (!value) {
        return '';
      }
      const date = filters.toDate(value);
      if (!date) {
        return '';
      }

      let year = date.getFullYear() + '';
      let month = (date.getMonth() + 1) + '';
      month = (month.length === 2) ? month : '0' + month;
      let day = date.getDate() + '';
      day = (day.length === 2) ? day : '0' + day;
      let hours = date.getHours() + '';
      hours = (hours.length === 2) ? hours : '0' + hours;
      let minutes = date.getMinutes() + '';
      minutes = (minutes.length === 2) ? minutes : '0' + minutes;

      return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
    },

    // Método para encadenar filtros como en Vue 2
    applyFilters(value, ...filterNames) {
      return filterNames.reduce((acc, filterName) => {
        return filters[filterName](acc);
      }, value);
    }
  }
};
